import {
  additionalYSpace,
  date2Str,
  noNanNum,
  timeParseNull2,
} from "@/_core/_helpers/_helpers";
import {
  calculateBalanceExpo,
  createProgramForBucket,
  createProgramForBucketBalance,
  nExposures,
  programEntry,
} from "@/_core/data/Advanced";
import { formatDate_YMDSlash } from "@/_core/_helpers/_helpers.js";
import { formatPercentSm } from "@/_core/_helpers/_parametric_tools";
import { getCommodityProgram } from "@/_core/data/api_calls/getCommodityProgram";
import { getCurrencyProgram } from "@/_core/data/api_calls/getCurrencyProgram";
import { getFutureExposureCommodityData } from "@/_core/data/api_calls/getFutureExposureCommodityData";
import { getFutureExposureData } from "@/_core/data/api_calls/getFutureExposureData";
import { getFutureHedgeCommodityData } from "@/_core/data/api_calls/getFutureHedgeCommodityData";
import { getFutureHedgeData } from "@/_core/data/api_calls/getFutureHedgeData";
import { Holidays } from "@/_core/_helpers/holidays/Holidays";
import { readCommodityValuationDataOptimizer } from "@/_core/data/api_calls/readCommodityValuationDataOptimizer";
import { readCurrencyValuationDataOptimizer } from "@/_core/data/api_calls/readCurrencyValuationDataOptimizer";
import { saveUserPreferences } from "@/_core/data/SaveToDB";
import { simulateStrategies } from "@/_core/data/api_calls/simulateStrategies";
import {
  max,
  nest,
  sum,
  timeDay,
  timeMonday,
  timeMonth,
  timeParse,
  timeYear,
  values,
} from "d3";
import { sortByKey } from "@/_core/_helpers/_helpers.js";
import moment from "moment";

export function timeCompare(date, intervalGroup, data) {
  // Nesting function, returns the appropriate date for nesting
  let dateCopy;
  let durfn;
  if (intervalGroup === "1D") {
    durfn = timeDay(date);
  } else if (intervalGroup === "1W") {
    durfn = timeMonday(date);
  } else if (intervalGroup === "2W") {
    dateCopy = timeDay(timeParseNull2(JSON.parse(JSON.stringify(date))));
    if (date.getDate() < 15) {
      durfn = timeDay(dateCopy.setDate(1));
    } else {
      durfn = timeDay(dateCopy.setDate(15));
    }
  } else if (intervalGroup === "1M") {
    durfn = timeMonth(date);
  } else if (intervalGroup === "1Q") {
    durfn = quarterDate(date);
  } else if (intervalGroup === "6M") {
    dateCopy = timeDay(timeParseNull2(JSON.parse(JSON.stringify(date))));
    if (dateCopy.getMonth() < 6) {
      durfn = timeDay(timeDay(dateCopy.setMonth(0)).setDate(1));
    } else {
      durfn = timeDay(timeDay(dateCopy.setMonth(6)).setDate(1));
    }
  } else if (intervalGroup === "1Y") {
    if (date.getFullYear() === data[0].date.getFullYear()) {
      durfn = timeDay(timeParseNull2(JSON.parse(JSON.stringify(data[0].date))));
    } else {
      durfn = timeYear(date);
    }
  } else if (intervalGroup === "all") {
    durfn = timeDay(timeParseNull2(JSON.parse(JSON.stringify(data[0].date))));
  }
  // if (durfn < data[0].date) {
  //   durfn = timeDay(
  //     timeParseNull2(
  //       JSON.parse(JSON.stringify(data[0].date))
  //     )
  //   );
  // }
  return durfn;
}
export function monthDiff(d1, d2) {
  // Months between two dates
  let months;
  months = (d2.getFullYear() - d1.getFullYear()) * 12;
  months += d2.getMonth() - d1.getMonth();
  return months <= 0 ? 0 : months;
}
export function setMax(data, xRange, intervalGroup) {
  if (xRange.length > 0) {
    let xMax = timeDay(
      timeParseNull2(JSON.parse(JSON.stringify(xRange[xRange.length - 1]))),
    );
    if (intervalGroup === "1D") {
      xMax.setDate(xMax.getDate() + 1);
    } else if (intervalGroup === "1W") {
      xMax.setDate(xMax.getDate() + 7);
    } else if (intervalGroup === "2W") {
      xMax.setDate(xMax.getDate() + 15);
    } else if (intervalGroup === "1M") {
      xMax.setMonth(xMax.getMonth() + 1);
    } else if (intervalGroup === "1Q") {
      xMax.setMonth(xMax.getMonth() + 3);
    } else if (intervalGroup === "6M") {
      xMax.setMonth(xMax.getMonth() + 6);
    } else if (intervalGroup === "1Y") {
      xMax.setFullYear(xMax.getFullYear() + 1);
    } else if (intervalGroup === "all") {
      xMax = timeDay(
        timeParseNull2(JSON.parse(JSON.stringify(data[data.length - 1].date))),
      );
    }
    return timeDay(xMax);
  } else {
    return [];
  }
}
export function quarterDate(date) {
  // Return the quarter that the variable "date" belongs to, for nesting
  let tod = new Date();
  let mDiff = monthDiff(tod, date);
  let newDate;
  if (mDiff === 0) {
    newDate = timeMonth(date);
  } else {
    let quarters = Math.floor(monthDiff(tod, date) / 3);
    newDate = timeDay(
      timeDay(tod.setMonth(tod.getMonth() + 3 * quarters + 1)).setDate(1),
    );
  }
  return newDate;
}
export function futureExpoData(_this) {
  let dateList = _this.processData.createWeekByWeekDays(
    _this.initialDate,
    _this.finalDate,
  );
  let dataRaw = [];
  dateList.forEach((d) =>
    dataRaw.push({
      date: d,
      delta: 0,
      notional: 0,
      trade_date: d,
      cash_flow: 0,
      balance: 0,
      fwd: 0,
      hedge: 0,
      hedgeValue: 0,
      premium: 0,
      program: 0,
      portfolio: "",
      undated: 0,
    }),
  );
  return dataRaw;
}
export function latestHedgesRefDate(selectedTime) {
  let refDate;
  if (selectedTime === "WEEK") {
    refDate = new Date(new Date().setDate(new Date().getDate() - 7));
  } else if (selectedTime === "2 WEEKS") {
    refDate = new Date(new Date().setDate(new Date().getDate() - 15));
  } else {
    refDate = new Date(new Date().setMonth(new Date().getMonth() - 1));
  }
  return refDate;
}
// ===== nest ===== //
// buckets future expo and hedges
export function dataCompressCurrency(
  _this,
  data,
  intervalGroup,
  resultField,
  futureBool,
  isCents = 1,
) {
  // TODO: a esto le falta todo el cambio de base currency
  let refDate = latestHedgesRefDate(_this.selectedExecutionTime);
  _this[resultField] = nest()
    .key(function(d) {
      return timeCompare(d.date, intervalGroup, data);
    })
    .rollup(function(v) {
      let date = timeCompare(values(v).pop().date, intervalGroup, data);
      let balance = sum(v, function(d) {
        return d.balance;
      });
      let undated = sum(v, function(d) {
        return d.undated;
      });
      let cash_flow = sum(v, function(d) {
        return d.cash_flow;
      });
      let program = sum(v, function(d) {
        return d.program;
      });
      let hedge = sum(v, function(d) {
        return d.hedge;
      });
      let last_m_hedge = sum(v, function(d) {
        return d.trade_date >= refDate ? d.hedge : 0;
      });
      let tot_cf = sum(v, function(d) {
        return d.cash_flow + d.balance;
      });
      let newHedge = sum(v, function(d) {
        return d.newHedge;
      });
      let expo_aux = balance + cash_flow;
      let hedge_aux = Math.sign(hedge) * hedge;
      expo_aux = Math.sign(expo_aux) * expo_aux;
      let totalHedgePercent =
        (expo_aux !== 0 ? (newHedge + hedge_aux) / expo_aux : 0) * 100;
      let newHedgePercent = (expo_aux !== 0 ? newHedge / expo_aux : 0) * 100;
      // Rates
      let m2m_rate =
        sum(v, function(d) {
          return d.fwd * (d.cash_flow + d.balance);
        }) / tot_cf;
      let hedge_rate =
        (sum(v, function(d) {
          return d.fwd * d.hedge;
        }) +
          sum(v, function(d) {
            return d.hedgeValue;
          }) /
            isCents) /
        hedge;
      let net_rate =
        (sum(v, function(d) {
          return d.fwd * (d.cash_flow + d.balance);
        }) +
          sum(v, function(d) {
            return d.hedgeValue;
          }) /
            isCents) /
        tot_cf;
      // Mark to market
      let m2m = sum(v, function(d) {
        return d.fwd * (d.cash_flow + d.balance) * isCents;
      });
      let hedge_m2m = sum(v, function(d) {
        return d.hedgeValue;
      });
      let net_m2m = m2m + hedge_m2m;
      // delta
      let delta = sum(v, function(d) {
        return d.delta * d.notional;
      });
      return {
        date: date,
        balance: balance,
        undated: undated,
        cash_flow: cash_flow,
        delta: delta,
        program: program,
        newHedge: newHedge,
        totalHedgePercent: totalHedgePercent,
        newHedgePercent: newHedgePercent,
        hedge: hedge,
        last_m_hedge: last_m_hedge,
        m2m_rate: m2m_rate,
        hedge_rate: Number.isFinite(hedge_rate) ? hedge_rate : m2m_rate,
        net_rate: net_rate,
        m2m: m2m,
        hedge_m2m: hedge_m2m,
        net_m2m: net_m2m,
      };
    })
    .entries(data)
    .map(function(d) {
      return d.value;
    });
  _this[resultField].forEach(function(d, i) {
    d.id = i;
  });
  // ================== Functions Calls ==========================
  if (futureBool) {
    _this.xRange = _this[resultField].map((d) => d.date);
    _this.xRange.push(setMax(data, _this.xRange, intervalGroup));
    if (!_this.zoomInitialized) {
      _this.zoomInitial = 0;
      _this.zoomFinal = Math.max(1, _this.xRange.length - 2);
      _this.zoomInitialized = true;
    }
  } else if (intervalGroup === "1M") {
    _this.zoomPastXRange = _this[resultField].map((d) => d.date);
    _this.zoomPastXRange.push(
      setMax(data, _this.zoomPastXRange, intervalGroup),
    );
    if (!_this.zoomPastInitialized) {
      _this.zoomInitialPast = Math.max(0, _this.zoomPastXRange.length - 12);
      _this.zoomFinalPast = Math.max(1, _this.zoomPastXRange.length - 2);
      _this.zoomPastInitialized = true;
    }
  }
}
export function getFinalDateExpoHedge(_this) {
  _this.finalDate = max([
    _this.finalDate,
    max(_this.expoDataRaw, function(d) {
      return Number.isFinite(d[_this.expoDateField])
        ? d[_this.expoDateField]
        : -Infinity;
    }),
  ]);
  _this.finalDate = max([
    _this.finalDate,
    max(_this.hedgeDataRaw, function(d) {
      return Number.isFinite(d[_this.hedgeDateField])
        ? d[_this.hedgeDateField]
        : -Infinity;
    }),
  ]);
}
export function pastExpoData(_this) {
  let dataRaw = [];
  _this.historicalDataRaw.forEach((d) =>
    dataRaw.push({
      date: d.date,
      delta: 0,
      notional: 0,
      cash_flow: 0,
      balance: 0,
      fwd: 0,
      hedge: 0,
      hedgeValue: 0,
      premium: 0,
      program: 0,
      portfolio: "",
      undated: 0,
    }),
  );
  return dataRaw;
}
// ===== charts data ===== //
export function createChartsDataRaw(
  _this,
  expoField,
  hedgeField,
  programField,
  resultField,
  futureBool,
) {
  let dataRaw = [];
  if (futureBool === true) {
    getFinalDateExpoHedge(_this);
    dataRaw = futureExpoData(_this);
  } else {
    dataRaw = pastExpoData(_this);
  }
  let today = new Date();
  let dat = [];
  if (_this[expoField].length > 0) {
    dat = _this[expoField].map(function(d) {
      return {
        date: d[_this.expoDateField] !== null ? d[_this.expoDateField] : today,
        delta: 0,
        notional: 0,
        trade_date: 0,
        cash_flow: d.cash_flow,
        balance: d.balance,
        fwd: futureBool ? d.fwd : d.settlement_rate,
        hedge: 0,
        hedgeValue: 0,
        premium: 0,
        program: 0,
        portfolio: d.portfolio,
        undated: d.undated,
        newHedge: 0,
      };
    });
  }
  if (futureBool) {
    dat = includeProgramNotional(dat, _this[programField]);
  } else {
    dat = includePastProgramNotional(dat, _this[programField]);
  }

  let dat2 = [];
  if (_this[hedgeField].length > 0) {
    dat2 = _this[hedgeField].map(function(d) {
      let condition = hedgeCondition(d.derivative_purpose);
      return {
        date: d[_this.hedgeDateField],
        delta: d.delta,
        notional: d.notional,
        trade_date: d.trade_date,
        cash_flow: 0,
        balance: 0,
        fwd: futureBool ? d.fwd : d.settlement_rate,
        hedge: condition ? d.hedgeNotional : 0,
        hedgeValue: d.hedge_value,
        premium: d.premium,
        program: 0,
        portfolio: "",
        undated: 0,
      };
    });
  }
  _this[resultField] = dat.concat(dat2.concat(dataRaw));
  _this[resultField] = sortByKey(_this[resultField], "date");
}
// ===== helpers ===== //
export function hedgeCondition(d) {
  return (
    d === "hedge" ||
    d === "limited_hedge" ||
    d === "hedge_and_reduce_cost" ||
    d === "ko_hedge"
  );
}
export function includeProgramNotional(expoData, program) {
  let today;
  let lastDate;

  program.forEach(function(d) {
    if (typeof d.flow != "object") {
      d.flow = JSON.parse(d.flow);
    }
    let portfolio = d.fk_idportfolio;
    if (d.objective.toUpperCase() === "BALANCE") {
      let program2Assign = calculateBalanceExpo(expoData, portfolio);
      let months;
      if (d.parameters.toUpperCase() === "MATCH") {
        today = new Date();
        lastDate = max(expoData, function(item) {
          return item.date !== null ? item.date : today;
        });
        program2Assign = (d.flow.values.percentage / 100) * program2Assign;
        let cashFlow = sum(expoData, function(item) {
          return Number.isFinite(item.balance) && item.balance != null
            ? item.balance
            : 0;
        });
        let percentage = Math.min(1, program2Assign / cashFlow);
        expoData.forEach(function(dat) {
          if (
            dat.portfolio === portfolio &&
            dat.date > today &&
            dat.date <= lastDate
          ) {
            dat.program = percentage * dat.balance;
          }
        });
        if (
          (cashFlow >= 0 && program2Assign > cashFlow) ||
          (cashFlow < 0 && program2Assign < cashFlow)
        ) {
          expoData.push(
            programEntry(lastDate, program2Assign, cashFlow, portfolio),
          );
        }
      } else if (d.parameters.toUpperCase() === "CONSTANT") {
        months = d.flow.values.months;
        program2Assign =
          (program2Assign * d.flow.values.percentage) / 100 / months;
        today = new Date();
        lastDate = new Date(today.getFullYear(), today.getMonth() + 1, 0);
        let i = 0;
        while (i < months) {
          createProgramForBucket(
            expoData,
            program2Assign,
            portfolio,
            today,
            lastDate,
          );
          today = lastDate;
          lastDate = new Date(
            lastDate.getFullYear(),
            lastDate.getMonth() + 2,
            0,
          );
          i += 1;
        }
      } else if (d.parameters.toUpperCase() === "MONTHLY") {
        let num = 0;
        months = d.flow.values;
        today = new Date();
        lastDate = new Date(today.getFullYear(), today.getMonth() + 1, 0);
        for (const i in months) {
          num = nExposures(expoData, portfolio, today, lastDate);
          if (num === 0) {
            expoData = createProgramForBucketBalance(
              expoData,
              (months[i] * program2Assign) / 100,
              portfolio,
              today,
              lastDate,
            );
          } else {
            createProgramForBucket(
              expoData,
              (months[i] * program2Assign) / 100,
              portfolio,
              today,
              lastDate,
            );
          }
          today = lastDate;
          lastDate = new Date(
            lastDate.getFullYear(),
            lastDate.getMonth() + 2,
            0,
          );
        }
      } else if (d.parameters.toUpperCase() === "QUARTERLY") {
        let num = 0;
        let quarters = d.flow.values;
        today = new Date();
        lastDate = new Date(today.getFullYear(), today.getMonth() + 4, 0);
        for (const i in quarters) {
          num = nExposures(expoData, portfolio, today, lastDate);
          if (num === 0) {
            expoData = createProgramForBucketBalance(
              expoData,
              (quarters[i] * program2Assign) / 100,
              portfolio,
              today,
              lastDate,
            );
          } else {
            createProgramForBucket(
              expoData,
              (quarters[i] * program2Assign) / 100,
              portfolio,
              today,
              lastDate,
            );
          }
          today = lastDate;
          lastDate = new Date(
            lastDate.getFullYear(),
            lastDate.getMonth() + 4,
            0,
          );
        }
      }
    } else {
      if (d.parameters.toUpperCase() === "CONSTANT") {
        today = new Date();
        lastDate = new Date(
          today.getFullYear(),
          today.getMonth() + d.flow.values.months + 1,
          0,
        );
        let perc = d.flow.values.percentage;
        expoData.forEach(function(item) {
          if (item.portfolio === portfolio && item.date <= lastDate) {
            item.program = ((item.balance + item.cash_flow) * perc) / 100;
          }
        });
      } else if (d.parameters.toUpperCase() === "MONTHLY") {
        today = new Date();
        lastDate = new Date(today.getFullYear(), today.getMonth() + 2, 0);
        let months = d.flow.values;
        for (const i in months) {
          expoData.forEach(function(item) {
            if (
              item.portfolio === portfolio &&
              item.date > today &&
              item.date <= lastDate
            ) {
              item.program =
                ((item.balance + item.cash_flow) * months[i]) / 100;
            }
          });
          today = lastDate;
          lastDate = new Date(
            lastDate.getFullYear(),
            lastDate.getMonth() + 2,
            0,
          );
        }
      } else if (d.parameters.toUpperCase() === "QUARTERLY") {
        today = new Date();
        lastDate = new Date(today.getFullYear(), today.getMonth() + 4, 0);
        let quarters = d.flow.values;
        for (const i in quarters) {
          expoData.forEach(function(item) {
            if (
              item.portfolio === portfolio &&
              item.date > today &&
              item.date <= lastDate
            ) {
              item.program =
                ((item.balance + item.cash_flow) * quarters[i]) / 100;
            }
          });
          today = lastDate;
          lastDate = new Date(
            lastDate.getFullYear(),
            lastDate.getMonth() + 4,
            0,
          );
        }
      } else if (d.parameters.toUpperCase() === "BUDGET") {
        today = new Date();
        lastDate = new Date(
          today.getFullYear(),
          d.flow.values.percentagemonths - 1,
          0,
        );
        let monthDist =
          12 * (lastDate.getFullYear() - today.getFullYear()) +
          (lastDate.getMonth() - today.getMonth());
        while (monthDist < 3) {
          lastDate = new Date(
            lastDate.getFullYear(),
            lastDate.getMonth() + 13,
            0,
          );
          monthDist =
            12 * (lastDate.getFullYear() - today.getFullYear()) +
            (lastDate.getMonth() - today.getMonth());
        }
        let perc = d.flow.values.percentage;
        expoData.forEach(function(item) {
          if (item.portfolio === portfolio && item.date <= lastDate) {
            item.program = ((item.balance + item.cash_flow) * perc) / 100;
          }
        });
      }
    }
  });
  return expoData;
}
export function includePastProgramNotional(expoData, program) {
  let portfolio;
  let percentage;
  let months;
  program.forEach(function(d) {
    portfolio = d.fk_idportfolio;
    if (typeof d.flow != "object") {
      d.flow = JSON.parse(d.flow);
    }

    if (d.objective.toUpperCase() === "BALANCE") {
      percentage = 0;
      if (
        d.parameters.toUpperCase() === "MATCH" ||
        d.parameters.toUpperCase() === "CONSTANT"
      ) {
        percentage = d.flow.values.percentage / 100;
      } else if (
        d.parameters.toUpperCase() === "MONTHLY" ||
        d.parameters.toUpperCase() === "QUARTERLY"
      ) {
        months = d.flow.values;
        for (const i in months) {
          percentage += months[i];
        }
        percentage = percentage / 100;
      }
    } else {
      if (
        d.parameters.toUpperCase() === "BUDGET" ||
        d.parameters.toUpperCase() === "CONSTANT"
      ) {
        percentage = d.flow.values.percentage / 100;
      } else if (
        d.parameters.toUpperCase() === "MONTHLY" ||
        d.parameters.toUpperCase() === "QUARTERLY"
      ) {
        months = d.flow.values;
        percentage = months[0] / 100;
      }
    }
  });
  expoData.forEach(function(dat) {
    dat.program =
      dat.portfolio === portfolio
        ? (dat.balance + dat.cash_flow) * percentage
        : 0;
  });
  return expoData;
}
// ===== base currency ===== //
export function baseCurrencyFn(_this) {
  _this.baseCurrency = {
    rate: "N.A.",
    foreign: "N.A.",
    base: "N.A.",
    changeBase: "N.A.",
  };
  if (_this.expoDataRaw.length > 0) {
    let curr = _this.expoDataRaw[0].currency;
    _this.baseCurrency.rate = _this.expoDataRaw[0].currency;
    _this.baseCurrency.foreign =
      "foreign_currency" in Object.keys(_this.expoDataRaw[0])
        ? _this.expoDataRaw[0].foreign_currency
        : curr.slice(0, 3);
    if (curr.slice(0, 3) === _this.baseCurrency.foreign) {
      _this.baseCurrency.base = curr.slice(3, 6);
    } else {
      _this.baseCurrency.base = curr.slice(0, 3);
    }
  } else if (_this.hedgeDataRaw.length > 0) {
    let curr = _this.hedgeDataRaw[0].currency;
    _this.baseCurrency.rate = _this.hedgeDataRaw[0].currency;
    _this.baseCurrency.foreign =
      "foreign_currency" in Object.keys(_this.hedgeDataRaw[0])
        ? _this.expoDataRaw[0].foreign_currency
        : curr.slice(0, 3);
    if (curr.slice(0, 3) === _this.baseCurrency.foreign) {
      _this.baseCurrency.base = curr.slice(3, 6);
    } else {
      _this.baseCurrency.base = curr.slice(0, 3);
    }
  }
}
export function getCountriesPair(_this) {
  let countryPerCurrency = [
    _this.currencySpecs[_this.selectedAsset].fk_idcurrency_left,
    _this.currencySpecs[_this.selectedAsset].fk_idcurrency_right,
  ];
  return [
    _this.countrySpecs.filter(
      (d) => d.pk_idcountry === countryPerCurrency[0],
    )[0].iso,
    _this.countrySpecs.filter(
      (d) => d.pk_idcountry === countryPerCurrency[1],
    )[0].iso,
  ];
}

export function holidaysCorrection(_this, country = null) {
  let holidays;
  if (country == null) {
    holidays = new Holidays(getCountriesPair(_this));
  } else {
    holidays = new Holidays(country);
  }
  _this.userNewHedge.forEach(function(d) {
    d.date = holidays.searchAvailableDate(d.date);
  });
}

export function createSelectedHedge(initialDate, notional, nDates, frequency) {
  initialDate = timeParse("%Y-%m-%d")(initialDate);
  let createdStrip;
  createdStrip = null;
  if (
    initialDate != null &&
    notional != null &&
    nDates != null &&
    frequency != null
  ) {
    createdStrip = [
      {
        date: date2Str(initialDate, 0),
        newHedge: notional,
      },
    ];
    var newDate = initialDate;
    var i;
    for (i = 0; i < nDates - 1; i++) {
      newDate = nextDateByFrequency(frequency, newDate);
      createdStrip.push({
        date: date2Str(newDate, 0),
        newHedge: notional,
      });
    }
  }
  return createdStrip;
}

export function nextDateByFrequency(frequency, newDate) {
  if (frequency === "D") {
    if (newDate.getDay() === 5) {
      newDate.setDate(newDate.getDate() + 3);
    } else {
      newDate.setDate(newDate.getDate() + 1);
    }
  } else if (frequency === "W") {
    newDate.setDate(newDate.getDate() + 7);
  } else if (frequency === "2W") {
    if (newDate.getDate() > 15) {
      newDate.setDate(newDate.getDate() - 15);
      newDate.setMonth(newDate.getMonth() + 1);
    } else {
      newDate.setDate(newDate.getDate() + 15);
    }
  } else if (frequency === "M") {
    newDate.setMonth(newDate.getMonth() + 1);
  } else if (frequency === "Q") {
    newDate.setMonth(newDate.getMonth() + 3);
  } else if (frequency === "S") {
    newDate.setMonth(newDate.getMonth() + 6);
  } else {
    newDate.setFullYear(newDate.getFullYear() + 1);
  }
  return newDate;
}

export function defineStrategyProfile(_this) {
  let pos = _this.selectedPosition === 1 ? "rProfileBuyer" : "rProfileSeller";
  _this.strategies.forEach(function(d) {
    d.rProfile = d[pos];
  });
}

export function positionSign(pos) {
  return pos.toUpperCase() === "LONG" ? "+" : "-";
}

export function initializeStrategiesRProfile(_this, justOne = false) {
  if (_this.selectedRiskProfile < 5 && _this.strategiesList.length > 0) {
    _this.strategies = [];
    let strats = strategiesIndex(
      _this.selectedRiskProfile,
      _this.selectedPosition,
    );
    if (justOne) {
      includeStrategy(
        _this,
        _this.strategiesList[strats[0]],
        _this.selectedPosition,
      );
    } else {
      strats.forEach(function(d) {
        includeStrategy(_this, _this.strategiesList[d], _this.selectedPosition);
      });
      _this.strategies.forEach(function(d, i) {
        d.show = false;
        d.id = i;
      });
      // _this.strategies[0].show = true;
      _this.selectedStrategy = {};
    }
  }
}

export function strategiesIndex(rProfile, position) {
  let strat;
  if (rProfile === 0) {
    if (position === 1) {
      strat = [0, 4, 16]; // , 18];
    } else {
      strat = [1, 6, 17]; // , 19];
    }
  } else if (rProfile === 1) {
    if (position === 1) {
      strat = [0, 8, 10]; // , 14];
    } else {
      strat = [1, 9, 12]; // , 15];
    }
  } else if (rProfile === 2) {
    if (position === 1) {
      strat = [0, 20, 22]; // , 26];
    } else {
      strat = [1, 21, 23]; // , 27];
    }
  } else if (rProfile === 3) {
    if (position === 1) {
      strat = [0, 30, 38];
    } else {
      strat = [1, 31, 39];
    }
  } else if (rProfile === 4) {
    if (position === 1) {
      strat = [0, 34, 40];
    } else {
      strat = [1, 35, 41];
    }
  } else {
    if (position === 1) {
      strat = [0];
    } else {
      strat = [1];
    }
  }
  return strat;
}

export function includeStrategy(_this, item, position) {
  let strat = {
    pk:
      _this.selectedAssetLink === 0
        ? item.pk_idcurrencystrategy
        : item.pk_idcommoditystrategy,
    numLegs: item.number_of_derivatives,
    data: [],
    id: _this.strategies.length,
    fixedCost: true,
    objectiveLeg: 1,
    first_second_strike_equal: item.first_second_strike_equal,
    name: item.name,
    rProfile:
      position === 1 ? item.risk_profile_buyer : item.risk_profile_seller,
    rProfileBuyer: item.risk_profile_buyer,
    rProfileSeller: item.risk_profile_seller,
    leg1:
      positionSign(item.first_derivative_position) +
      " " +
      item.first_derivative.toUpperCase(),
    leg2:
      item.number_of_derivatives >= 2
        ? positionSign(item.second_derivative_position) +
          " " +
          item.second_derivative.toUpperCase()
        : null,
    leg3:
      item.number_of_derivatives >= 3
        ? positionSign(item.third_derivative_position) +
          " " +
          item.third_derivative.toUpperCase()
        : null,
    leg4:
      item.number_of_derivatives === 4
        ? positionSign(item.fourth_derivative_position) +
          " " +
          item.fourth_derivative.toUpperCase()
        : null,
    isStrip1: false,
    isStrip2: false,
    isStrip3: false,
    isStrip4: false,
    derivative1: 1,
    derivative2: 1,
    derivative3: 1,
    derivative4: 1,
    strike1: 0,
    strike2: 0,
    strike3: 0,
    strike4: 0,
    barrier1: 0,
    barrier2: 0,
    barrier3: 0,
    barrier4: 0,
    barrier1_2: 0,
    barrier2_2: 0,
    barrier3_2: 0,
    barrier4_2: 0,
    cost:
      item.fk_idstrategyname === "FORWARD" ||
      item.fk_idstrategyname === "FUTURE"
        ? null
        : 0,
    costPerc: 0,
    active: true,
    percentage: 0,
    show: true,
    showLoading: false,
    calculated: false,
    simulated: false,
    warning: null,
  };
  _this.strategies.push(strat);
  _this.selectedStrategy = strat;
}

export const OptimizerManager = function(_SelectedAsset, context) {
  this.selectedAsset = _SelectedAsset;
  this.asset = null;
  if (this.selectedAsset === 1) {
    this.asset = new CommoditiesOptimizer(context);
  } else if (this.selectedAsset === 0) {
    this.asset = new CurrenciesOptimizer(context);
  }
};

OptimizerManager.prototype.loadData = function() {
  this.asset.loadData();
};

OptimizerManager.prototype.setLoadData = function() {
  this.asset.setLoadData();
};

OptimizerManager.prototype.processBucket = function(
  bucket,
  lastBucket,
  objectNewHedge,
) {
  this.asset.processDatabyBucket(bucket, lastBucket, objectNewHedge);
};

OptimizerManager.prototype.buildJsonStepOne = function() {
  this.asset.buildJsonStepOne();
};

OptimizerManager.prototype.mergeOnSpotChange = function(_this) {
  this.asset.mergeFromInputsValuation(_this);
};

export const CommoditiesOptimizer = function(context) {
  this.context = context;
};

export const CurrenciesOptimizer = function(context) {
  this.context = context;
};

CurrenciesOptimizer.prototype.loadData = function() {
  this.context.showLoadingTopographyCalcsRates = true;
  this.context.showLoadingFutExpo = true;
  this.context.showLoadingFutHedge = true;
  this.context.showLoadingProgram = true;
  getFutureExposureData(this.context, "expoDataRaw", "showLoadingFutExpo");
  getFutureHedgeData(this.context, "hedgeDataRaw", "showLoadingFutHedge");
  getCurrencyProgram(this.context, "programData", "showLoadingProgram");
};
CommoditiesOptimizer.prototype.loadData = function() {
  this.context.showLoadingTopographyCalcsRates = true;
  this.context.showLoadingFutExpo = true;
  this.context.showLoadingFutHedge = true;
  this.context.showLoadingProgram = true;
  getFutureExposureCommodityData(
    this.context,
    "expoDataRaw",
    "showLoadingFutExpo",
  );
  getFutureHedgeCommodityData(
    this.context,
    "hedgeDataRaw",
    "showLoadingFutHedge",
  );
  getCommodityProgram(this.context, "programData", "showLoadingProgram");
};

CurrenciesOptimizer.prototype.setLoadData = function() {
  let _this = this.context;
  createChartsDataRaw(
    _this,
    "expoDataRaw",
    "hedgeDataRaw",
    "programData",
    "dataRaw",
    true,
  );
  dataCompressCurrency(_this, _this.dataRaw, _this.pickedBucket, "data", true);
  this.processData();
  _this.selectedHedge.splice(0, _this.selectedHedge.length);
  _this.data.forEach(function(row) {
    _this.selectedHedge.push({
      date: formatDate_YMDSlash(row.date),
      expo: Math.sign(row.tot) * row.tot,
      hedge: Math.sign(row.hedge) * row.hedge,
      program: Math.sign(row.program) * row.program,
      newHedge: 0,
      newHedgePercent: 0,
      totalHedgePercent: 0,
    });
  });
  _this.onUserTotalPercOfRequiredChange(_this.totalPercOfRequired);
  _this.selectedHedgeSignal += 1;
};
CommoditiesOptimizer.prototype.setLoadData = function() {
  let _this = this.context;
  createChartsDataRaw(
    _this,
    "expoDataRaw",
    "hedgeDataRaw",
    "programData",
    "dataRaw",
    true,
  );
  dataCompressCurrency(_this, _this.dataRaw, _this.pickedBucket, "data", true);
  this.processData();
  if (_this.selectedHedge.length > 0) {
    _this.selectedHedge.splice(0, _this.selectedHedge.length);
  }
  _this.data.forEach(function(row) {
    _this.selectedHedge.push({
      date: formatDate_YMDSlash(row.date),
      expo: Math.sign(row.tot) * row.tot,
      hedge: Math.sign(row.hedge) * row.hedge,
      program: Math.sign(row.program) * row.program,
      newHedge: 0,
      newHedgePercent: 0,
      totalHedgePercent: 0,
    });
  });
  _this.onUserTotalPercOfRequiredChange(_this.totalPercOfRequired);
  _this.selectedHedgeSignal += 1;
};

CurrenciesOptimizer.prototype.processData = function() {
  let _this = this.context;
  _this.data.forEach(function(d) {
    d.tot = d.balance + d.cash_flow;
  });
  _this.data.forEach(function(d) {
    d.hedgeP = d.tot !== 0 ? formatPercentSm(d.hedge / d.tot) : "";
    d.programP = d.tot !== 0 ? formatPercentSm(d.program / d.tot) : "";
  });
  _this.data.forEach(function(d) {
    d.excess = 0;
    d.program =
      d.program === 0 && d.balance + d.cash_flow === 0 ? 0 : d.program;
  });
  baseCurrencyFn(_this);
};

CommoditiesOptimizer.prototype.processData = function() {
  let _this = this.context;
  _this.data.forEach(function(d) {
    d.tot = d.balance + d.cash_flow;
  });
  _this.data.forEach(function(d) {
    d.hedgeP = d.tot !== 0 ? formatPercentSm(d.hedge / d.tot) : "";
    d.programP = d.tot !== 0 ? formatPercentSm(d.program / d.tot) : "";
  });
  _this.data.forEach(function(d) {
    d.excess = 0;
    d.program =
      d.program === 0 && d.balance + d.cash_flow === 0 ? 0 : d.program;
  });
};

CurrenciesOptimizer.prototype.processDatabyBucket = function(
  bucket,
  intervalGroup,
  objectNewHedge,
) {
  let _this = this.context;
  unCompressData(_this, _this.dataRaw, intervalGroup, objectNewHedge);
  dataCompressCurrency(_this, _this.dataRaw, bucket, "data", true);
  this.processData();
  _this.selectedHedge.splice(0, _this.selectedHedge.length);
  _this.data.forEach(function(row) {
    _this.selectedHedge.push({
      date: formatDate_YMDSlash(row.date),
      expo: Math.sign(row.tot) * row.tot,
      hedge: Math.sign(row.hedge) * row.hedge,
      program: Math.sign(row.program) * row.program,
      newHedge: noNanNum(row.newHedge),
      newHedgePercent: noNanNum(row.newHedgePercent),
      totalHedgePercent: noNanNum(row.totalHedgePercent),
    });
  });
  _this.onUserTotalPercOfRequiredChange(_this.totalPercOfRequired);
  _this.selectedHedgeSignal += 1;
};
CommoditiesOptimizer.prototype.processDatabyBucket = function(
  bucket,
  intervalGroup,
  objectNewHedge,
) {
  let _this = this.context;
  unCompressData(_this, _this.dataRaw, intervalGroup, objectNewHedge);
  dataCompressCurrency(_this, _this.dataRaw, bucket, "data", true);
  this.processData();
  _this.selectedHedge.splice(0, _this.selectedHedge.length);
  _this.data.forEach(function(row) {
    _this.selectedHedge.push({
      date: formatDate_YMDSlash(row.date),
      expo: Math.sign(row.tot) * row.tot,
      hedge: Math.sign(row.hedge) * row.hedge,
      program: Math.sign(row.program) * row.program,
      newHedge: noNanNum(row.newHedge),
      newHedgePercent: noNanNum(row.newHedgePercent),
      totalHedgePercent: noNanNum(row.totalHedgePercent),
    });
  });
  _this.onUserTotalPercOfRequiredChange(_this.totalPercOfRequired);
  _this.selectedHedgeSignal += 1;
};

CurrenciesOptimizer.prototype.buildJsonStepOne = function() {
  this.getValuationInput();
};
CommoditiesOptimizer.prototype.buildJsonStepOne = function() {
  this.getValuationInput();
};

CurrenciesOptimizer.prototype.getValuationInput = function() {
  let _this = this.context;
  let daysToExpiration = _this.hedgeTemplate.map((d) => d.days_to_expiration);
  _this["showLoadingValInputs"] = true;
  readCurrencyValuationDataOptimizer(_this, daysToExpiration)
    .then((data) => {
      _this["valuationDataRaw"] = data;
      _this["showLoadingValInputs"] = false;
      this.mergeFromInputsValuation(_this);
    })
    .catch(function(error) {
      _this["showLoadingValInputs"] = false;
      _this["valuationDataRaw"] = [];
      console.error(error);
    });
};

CommoditiesOptimizer.prototype.getValuationInput = function() {
  let _this = this.context;
  let daysToExpiration = _this.hedgeTemplate.map((d) => d.days_to_expiration);
  _this["showLoadingValInputs"] = true;
  readCommodityValuationDataOptimizer(_this, daysToExpiration)
    .then((data) => {
      data.forEach(function(d) {
        d.fwd = _this.spot;
      });
      Object.assign(_this, { valuationDataRaw: data });
      _this["showLoadingValInputs"] = false;
      this.mergeFromInputsValuation(_this);
    })
    .catch(function(error) {
      _this["showLoadingValInputs"] = false;
      _this["valuationDataRaw"] = [];
      console.error(error);
    });
};

CurrenciesOptimizer.prototype.mergeFromInputsValuation = async function(_this) {
  let indexes = _this.valuationDataRaw.map((d) => d.days_to_expiration);
  let idx;
  let item;
  _this.hedgeTemplate.forEach(function(d) {
    idx = indexes.indexOf(d.days_to_expiration);
    if (idx > -1) {
      item = _this.valuationDataRaw[idx];
      d.c0 = item.c0;
      d.c1 = item.c1;
      d.c2 = item.c2;
      d.d0 = item.d0;
      d.r = item.r;
      d.rf = item.rf;
      d.fwd = _this.spot * Math.exp(d.time * (d.r - d.rf));
    }
  });
  _this.prevHedgeTemplate = _this.hedgeTemplate;
  _this.finalDate = max(_this.hedgeTemplate, function(d) {
    return d.date;
  });
  dataCompressCurrency(
    _this,
    futureExpoData(_this).concat(_this.hedgeTemplate),
    "1M",
    "dataSliced",
    true,
  );
  await new Promise((resolve) => setTimeout(resolve, 1000));
  _this.minMaxYAxisHist = _this.processData.minMax(
    _this.dataSliced,
    "m2m_rate",
    "m2m_rate",
    _this.minMaxYAxisHist,
  );
  _this.minMaxYAxisRates = _this.processData.minMax(
    _this.hedgeData,
    "strike",
    "strike",
    [_this.minMaxYAxisHist[0], _this.minMaxYAxisHist[1]],
  );
  _this.minMaxYAxisRates = additionalYSpace(_this.minMaxYAxisRates, 0.05);
  _this.renderCharts += 1;
};

CommoditiesOptimizer.prototype.mergeFromInputsValuation = async function(
  _this,
) {
  let indexes = _this.valuationDataRaw.map((d) => d.days_to_expiration);
  let idx;
  let item;
  _this.hedgeTemplate.forEach(function(d) {
    idx = indexes.indexOf(d.days_to_expiration);
    if (idx > -1) {
      item = _this.valuationDataRaw[idx];
      d.c0 = item.c0;
      d.c1 = item.c1;
      d.c2 = item.c2;
      d.d0 = item.d0;
      d.r = item.r;
      d.fwd = item.fwd;
    }
  });
  _this.prevHedgeTemplate = _this.hedgeTemplate;
  _this.finalDate = max(_this.hedgeTemplate, function(d) {
    return d.date;
  });
  dataCompressCurrency(
    _this,
    futureExpoData(_this).concat(_this.hedgeTemplate),
    "1M",
    "dataSliced",
    true,
  );
  await new Promise((resolve) => setTimeout(resolve, 1000));
  _this.minMaxYAxisHist = _this.processData.minMax(
    _this.dataSliced,
    "m2m_rate",
    "m2m_rate",
    _this.minMaxYAxisHist,
  );
  _this.minMaxYAxisRates = _this.processData.minMax(
    _this.hedgeData,
    "strike",
    "strike",
    [_this.minMaxYAxisHist[0], _this.minMaxYAxisHist[1]],
  );
  _this.minMaxYAxisRates = additionalYSpace(_this.minMaxYAxisRates, 0.05);
  _this.renderCharts += 1;
};

export function getPortfolios(_this) {
  var port = [];
  var opt = [];
  if (_this.companies.length > 0) {
    port = _this.companies[_this.selectedCompany].portfolios;
  } else {
    port = _this.companies[0].portfolios;
  }
  for (let i = 0; i < port.length; i++) {
    if (port[i].fk_currency.length !== 0) {
      opt.push({
        id: i,
        pk: port[i].pk_idportfolio,
        name: port[i].portfolio_name,
        asset: port[i].fk_currency,
      });
    }
  }
  return opt;
}

export function getPortfoliosCommodities(_this) {
  var port = [];
  var opt = [];
  if (_this.companies.length > 0) {
    port = _this.companies[_this.selectedCompany].portfolios;
  } else {
    port = _this.companies[0].portfolios;
  }
  for (let i = 0; i < port.length; i++) {
    if (port[i].fk_idcommodity.length !== 0) {
      opt.push({
        id: i,
        pk: port[i].pk_idportfolio,
        name: port[i].portfolio_name,
        asset: port[i].fk_idcommodity,
      });
    }
  }
  return opt;
}

export function unCompressData(_this, data, intervalGroup, objectNewHedge) {
  let counter = 0;
  let actualPercentage;
  let expoNoEx;
  nest()
    .key(function(d) {
      return timeCompare(d.date, intervalGroup, data);
    })
    .rollup(function(v) {
      _this.totExpoNoEx = 0;
      _this.bucketExcess = 0;
      _this.percentage =
        objectNewHedge[counter].newHedge / objectNewHedge[counter].expo;
      _this.toChange = _this.percentage;
      v.forEach(function(item) {
        item.tot = item.balance + item.cash_flow;
        item.expo = Math.sign(item.tot) * item.tot;
        actualPercentage = item.expo !== 0 ? item.hedge / item.expo : 0;
        _this.totExpoNoEx += actualPercentage > _this.toChange ? 0 : item.expo;
        _this.bucketExcess += Math.max(
          0,
          item.hedge - item.expo * _this.toChange,
        );
      });

      v.forEach(function(item) {
        item.tot = item.balance + item.cash_flow;
        item.expo = Math.sign(item.tot) * item.tot;
        actualPercentage = item.expo !== 0 ? item.hedge / item.expo : 0;
        expoNoEx = actualPercentage > _this.toChange ? 0 : item.expo;
        item.newHedge =
          Math.max(0, _this.toChange - actualPercentage) * item.expo -
          (_this.bucketExcess * expoNoEx) / _this.totExpoNoEx;
        item.newHedge = Number.isNaN(item.newHedge) ? 0 : item.newHedge;
      });
      counter += 1;
    })
    .entries(data);
}

export function step1to2Currency(_this) {
  _this.hedgeTemplate = [];
  let idx = 0;
  if (_this.selectedTabNotional === 0) {
    _this.userNewHedge.forEach(function(d) {
      if (d.newHedge !== 0) {
        _this.hedgeTemplate.push(dataRawToTemplateHedge(idx, _this, d));
        idx += 1;
      }
    });
  } else {
    unCompressData(
      _this,
      _this.dataRaw,
      _this.pickedBucket,
      _this.selectedHedge,
    );
    _this.dataRaw.forEach(function(d) {
      if (d.newHedge !== 0) {
        _this.hedgeTemplate.push(dataRawToTemplateHedge(idx, _this, d));
        idx += 1;
      }
    });
  }
  // Delete repeated dates
  _this.hedgeTemplate = getRepeatedDates(_this.hedgeTemplate);
}

function getRepeatedDates(data) {
  const groupedData = {};

  data.forEach((item) => {
    const fixingDate = item.fixing_date;

    if (groupedData[fixingDate]) {
      groupedData[fixingDate].notional += item.notional;
    } else {
      groupedData[fixingDate] = {
        ...item,
      };
    }
  });

  const resultArray = Object.values(groupedData);
  return resultArray;
}

export function dataRawToTemplateHedge(idx, _this, d) {
  let days2Exp = moment(d.date).diff(moment(_this.todayDate), "days");
  let dat =
    _this.selectedTabNotional === 0 ? timeParse("%Y-%m-%d")(d.date) : d.date;
  let item = {
    asian_fixing_start_date: null,
    balance: 0,
    barrier_2_event: false,
    barrier_2: null,
    barrier_event: false,
    barrier: null,
    budget_rate: 0,
    buy_sell: "",
    c0: null,
    c1: null,
    c2: null,
    cash_flow: d.newHedge,
    comments: "",
    counterparty: "QUANSPIRE",
    counterpartys_id: null,
    curr: "",
    currency: "",
    d0: null,
    date: dat,
    days_to_expiration: days2Exp,
    delta: 0,
    derivative_purpose: "",
    derivative: "",
    derivative_type: "",
    dt_asian: null,
    dtn_asian: null,
    fixing_date: dat,
    fixation_date: dat,
    fwd: null,
    foreign_currency: "",
    hedge_value: 0,
    hedge: 0,
    hedgeNotional: null,
    hedgeValue: 0,
    hedged_date: null,
    historicalIndex: null,
    index: idx,
    known_ave: null,
    mark_2_market: 0,
    m_asian: null,
    new_event: false,
    notional: d.newHedge,
    option_type: "",
    pk: null,
    pk_idcurrencyhedge: null,
    portfolio: null,
    position: null,
    premium_value_date: _this.todayDate,
    premium: 0,
    premium_left: null,
    program: 0,
    quantity: d.newHedge,
    quantity_hedge: d.newHedge,
    r: null,
    ratio: 1,
    rf: null,
    sale_date: null,
    settlement_type: "NON DELIVERABLE",
    spot_reference: null,
    spot: null,
    strategy_code: null,
    strategy_name: "",
    strategy_value: 0,
    strike: 0,
    time: days2Exp / 365,
    trade_date: _this.todayDate,
    undated: 0,
    unit: "",
    updated_at: null,
    undelying_position: -_this.selectedPosition,
    value_date: dat,
    volatility: 0,
  };

  if (_this.selectedAssetLink === 0) {
    if (_this.selectedTabNotional === 0) {
      item.currency = _this.currencySpecs[_this.selectedAsset].currency_name;
      item.foreign_currency = _this.currencySpecs[
        _this.selectedAsset
      ].currency_name.slice(0, 3);
    } else {
      item.currency = _this.currencyString;
      item.portfolio = _this.portfolios[_this.selectedPortfolio].name;
    }
  } else {
    if (_this.selectedTabNotional === 0) {
      _this.commodityString =
        _this.commoditySpecs[_this.selectedAsset].fk_idproduct;
    } else {
      _this.commodityString = _this.assets[_this.selectedPortCommodity];
    }
    item.unit = _this.commoditySpecs[_this.selectedAsset].fk_idunit;
    item.curr = _this.commoditySpecs[_this.selectedAsset].fk_idcurrency;
    item.contract_month_year =
      _this.spotStrip[_this.contract - 1].contract_month_year;
    item.contract_month_year_hedge =
      _this.spotStrip[_this.contract - 1].contract_month_year;
  }

  return item;
}

export function getPlusCarouselPage() {
  let prevPage = document
    .getElementById("step-1-div")
    .className.includes("active")
    ? 0
    : document.getElementById("step-2-div").className.includes("active")
    ? 1
    : document.getElementById("step-3-div").className.includes("active")
    ? 2
    : 3;
  return prevPage === 3 ? 0 : prevPage + 1;
}

export function getMinusCarouselPage() {
  let prevPage = document
    .getElementById("step-1-div")
    .className.includes("active")
    ? 0
    : document.getElementById("step-2-div").className.includes("active")
    ? 1
    : document.getElementById("step-3-div").className.includes("active")
    ? 2
    : 3;
  return prevPage === 0 ? 3 : prevPage - 1;
}

export function writeStrategySummary(_this, idx, summary) {
  _this.strategies[idx].cost =
    summary[0]["cost"] == null ? null : -summary[0]["cost"];
  _this.strategies[idx].costPerc =
    -Math.round(summary[0]["costPerc"] * 10000) / 100;
  _this.strategies[idx].strike1 = summary[0]["strike1"];
  _this.strategies[idx].strike2 = summary[0]["strike2"];
  _this.strategies[idx].strike3 = summary[0]["strike3"];
  _this.strategies[idx].strike4 = summary[0]["strike4"];
  _this.strategies[idx].isStrip1 = summary[0]["isStrip1"];
  _this.strategies[idx].isStrip2 = summary[0]["isStrip2"];
  _this.strategies[idx].isStrip3 = summary[0]["isStrip3"];
  _this.strategies[idx].isStrip4 = summary[0]["isStrip4"];
  _this.strategies[idx].barrier1 = summary[0]["barrier1"];
  _this.strategies[idx].barrier2 = summary[0]["barrier2"];
  _this.strategies[idx].barrier3 = summary[0]["barrier3"];
  _this.strategies[idx].barrier4 = summary[0]["barrier4"];
  _this.strategies[idx].barrier1_2 = summary[0]["barrier1_2"];
  _this.strategies[idx].barrier2_2 = summary[0]["barrier2_2"];
  _this.strategies[idx].barrier3_2 = summary[0]["barrier3_2"];
  _this.strategies[idx].barrier4_2 = summary[0]["barrier4_2"];
  _this.strategies[idx].warning = summary[0]["warning"];
}

export function setBaseCurrency(_this) {
  let curr = _this.currencyString;
  _this.baseCurrency = {
    rate: curr,
    foreign: curr.slice(0, 3),
    base: curr.slice(3, 6),
    changeBase: "N.A.",
  };
}

export function filterCurrenciesWithValuationData(original) {
  let newData = [];
  let names = original.map((d) => d.currency_name);
  let idx;
  let availableCurrencies = [
    "EURGBP",
    "EURUSD",
    "GBPUSD",
    "USDBRL",
    "USDCLP",
    "USDCOP",
    "USDMXN",
    "USDMYR",
  ];
  availableCurrencies.forEach(function(d) {
    idx = names.indexOf(d);
    newData.push(original[idx]);
  });
  return newData;
}

function isLongOrShort(longShort) {
  return longShort === "long" ? "compra" : "vende";
}

export function createExcelForStrategy(_this, data, strategy) {
  let dat;
  let pk;
  _this.excelData = [];
  data
    .filter((d) => d.leg === 1)
    .forEach(function(d) {
      pk = d.pk;
      dat = {
        [_this.isCurrency ? "fixing_date" : "date"]: d.date,
        notional: d.notional,
        strike1: d.strike,
        strategy_name: d.strategy_name,
        spot_reference: d.spot_reference,
        premium: d.premium,
        premium_currency: `Prima ${d.currency}`,
        mark_2_market: d.mark_2_market,
        leg1: _this.isCurrency
          ? `${isLongOrShort(strategy.first_derivative_position)} ${
              strategy.first_derivative
            }`
          : d.strike,
      };
      if (!_this.isCurrency) {
        dat.label1 =
          strategy.first_derivative_position + " " + strategy.first_derivative;
      }
      _this.excelData.push(dat);
    });
  if (strategy.number_of_derivatives >= 2) {
    data
      .filter((d) => d.leg === 2)
      .forEach(function(d, i) {
        _this.excelData[i].strike2 = d.strike;
        _this.excelData[i].premium = _this.excelData[i].premium + d.premium;
        _this.excelData[i].mark_2_market =
          _this.excelData[i].mark_2_market + d.mark_2_market;
        _this.excelData[i].leg2 = _this.isCurrency
          ? `${isLongOrShort(strategy.second_derivative_position)} ${
              strategy.second_derivative
            }`
          : d.strike;
        if (!_this.isCurrency) {
          _this.excelData[i].label2 =
            strategy.second_derivative_position +
            " " +
            strategy.second_derivative;
        }
      });
  }
  if (strategy.number_of_derivatives >= 3) {
    data
      .filter((d) => d.leg === 3)
      .forEach(function(d, i) {
        _this.excelData[i].strike3 = d.strike;
        _this.excelData[i].premium = _this.excelData[i].premium + d.premium;
        _this.excelData[i].mark_2_market =
          _this.excelData[i].mark_2_market + d.mark_2_market;
        _this.excelData[i].leg3 = _this.isCurrency
          ? `${isLongOrShort(strategy.third_derivative_position)} ${
              strategy.third_derivative
            }`
          : d.strike;

        if (!_this.isCurrency) {
          _this.excelData[i].label3 =
            strategy.third_derivative_position +
            " " +
            strategy.third_derivative;
        }
      });
  }
  if (strategy.number_of_derivatives >= 4) {
    data
      .filter((d) => d.leg === 4)
      .forEach(function(d, i) {
        _this.excelData[i].strike4 = d.strike;
        _this.excelData[i].premium = _this.excelData[i].premium + d.premium;
        _this.excelData[i].mark_2_market =
          _this.excelData[i].mark_2_market + d.mark_2_market;
        _this.excelData[i].leg4 = _this.isCurrency
          ? `${isLongOrShort(strategy.fourth_derivative_position)} ${
              strategy.fourth_derivative
            }`
          : d.strike;

        if (!_this.isCurrency) {
          _this.excelData[i].label4 =
            strategy.fourth_derivative_position +
            " " +
            strategy.fourth_derivative;
        }
      });
  }

  if (pk) _this.accumExcelData[pk] = _this.excelData;
}

export function getObjectiveLeg(leg, selectedStrategy) {
  return leg === 1
    ? selectedStrategy.isStrip1
    : leg === 2
    ? selectedStrategy.isStrip2
    : leg === 3
    ? selectedStrategy.isStrip3
    : selectedStrategy.isStrip4;
}

export function buildPortfolioSimulations(_this, percentageById) {
  let keys = Object.keys(percentageById);
  delete keys.rates;
  delete keys.result;
  _this.simulations.forEach(function(d) {
    d.result =
      d.rates +
      sum(keys, function(key) {
        return (d[key] * percentageById[key]) / 100;
      });
  });
  _this.simulationsSliced.forEach(function(d) {
    d.result =
      d.rates +
      sum(keys, function(key) {
        return (d[key] * percentageById[key]) / 100;
      });
  });
  _this.renderSimulationChartSignal += 1;

  portfolioStatistics(_this);
}

export function portfolioStatistics(_this) {
  let not = _this.notionalTotal;
  let conf;
  if (_this.selectedPosition === -1) {
    conf = (100 - _this.confidence) / 200;
  } else {
    conf = 1 - (1 - _this.confidence / 100) / 2;
    not *= -1;
  }
  let arr = Array.from(_this.simulations, (d) => d.rates);
  let res = Array.from(_this.simulations, (d) => d.result).sort(function(a, b) {
    return a - b;
  });
  _this.portfolioStats.var = _this.processData.percentile(arr, conf);
  _this.portfolioStats.best = _this.processData.percentile(arr, 1 - conf);
  _this.portfolioStats.varH = _this.processData.percentile(res, conf);
  _this.portfolioStats.bestH = _this.processData.percentile(res, 1 - conf);
  _this.portfolioStats.ave = _this.processData.average(arr);
  _this.portfolioStats.aveH = _this.processData.average(res);
  _this.portfolioStats.varPnl = not * _this.portfolioStats.var;
  _this.portfolioStats.bestPnl = not * _this.portfolioStats.best;
  _this.portfolioStats.avePnl = not * _this.portfolioStats.ave;
  _this.portfolioStats.varPnlH = not * _this.portfolioStats.varH;
  _this.portfolioStats.bestPnlH = not * _this.portfolioStats.bestH;
  _this.portfolioStats.avePnlH = not * _this.portfolioStats.aveH;
}

// === OPTIMIZER: Ready to Simulate? === //
export function readyToSimulate(_this) {
  if (_this.carouselPage === 2) {
    let bool = true;
    _this.strategies.forEach(function(d) {
      if (d.calculated === false) {
        bool = false;
      }
    });
    let bool2 = true;
    _this.strategies.forEach(function(d) {
      if (d.simulated === false) {
        bool2 = false;
      }
    });
    if (bool && !bool2) {
      simulateStrategies(_this, "simulations", "showLoadingSimulating");
    }
    if (bool && bool2) {
      let percentageById = {};
      _this.strategies.forEach(function(d) {
        percentageById[d.id] = d.percentage;
      });
      setTimeout(() => {
        buildPortfolioSimulations(_this, percentageById);
      }, 1000);
    }
  }
}

export function simulationsDataPrep(_this) {
  _this.simulationsSliced = _this.simulations.slice(0, 1000);
  _this.simulations = _this.simulations.sort((a, b) =>
    a.rates > b.rates ? 1 : b.rates > a.rates ? -1 : 0,
  );
  _this.minMaxSim = [
    _this.simulations[0].rates,
    _this.simulations[_this.simulations.length - 1].rates,
  ];
  _this.minMaxSimP[0] = _this.processData.percentile(
    Array.from(_this.simulations, (d) => d.rates),
    0.05,
  );
  _this.minMaxSimP[1] = _this.processData.percentile(
    Array.from(_this.simulations, (d) => d.rates),
    0.95,
  );
}

export function highlightOnOff(_this, fieldName) {
  _this[fieldName] = true;
  setTimeout(() => {
    _this[fieldName] = false;
  }, 500);
}

export function getDefaultOptimizerPreferences(_this) {
  const items = _this.$store.state.user_preferences.all?.items;
  const optimizer_choices = items?.optimizer_choices;
  if (!optimizer_choices || Object.keys(optimizer_choices).length === 0) {
    let choices = {
      selected_nav: 0,
      selected_currency: 2,
      selected_commodity: 7,
      color_theme: false,
      buy_sell: 0,
      select: 0,
    };
    if (items) {
      items.optimizer_choices = choices;
      saveUserPreferences(_this);
    }
    return { choices };
  } else {
    return { choices: optimizer_choices };
  }
}
